import { DocumentType, DocumentTypeDocumentClassification, DocumentTypeTemplateManager, DocumentTypeTreeNode, ELynkPacket, ELynkPacketAdd, ELynkPacketChecklist } from './document-type.model';


export class GetDocumentTypesRequest {

}

export class GetDocumentTypesResponse {
    documentTypes: DocumentTypeTreeNode[];
}

export class GetDocumentTypeRequest {
    documentTypeId: number;
    constructor(documentTypeId: number) {
        this.documentTypeId = documentTypeId;
    }
}

export class GetDocumentTypeResponse {
    documentType: DocumentType;
}

export class SaveDocumentTypeRequest {
    documentType: DocumentType;
    constructor(documentType: DocumentType) {
        this.documentType = documentType;
    }
}

export class SaveDocumentTypeResponse {
    documentTypeId: number;
    statusCode: number;
}

export class DeleteDocumentTypeRequest {
    documentTypeId: number;
    constructor(documentTypeId: number) {
        this.documentTypeId = documentTypeId;
    }
}

export class DeleteDocumentTypeResponse {
    statusCode: number;
}

/**   eLynk Checklist */
export class SaveElynkChecklistRequest {
    documentTypeId: number;
    packetId: string;
    checklist: ELynkPacketChecklist;
    constructor(documentId: number, packetId: string, checklist: ELynkPacketChecklist) {
        this.documentTypeId = documentId;
        this.packetId = packetId;
        this.checklist = checklist;
    }
}

export class SaveElynkChecklistResponse {
    statusCode: number;
}

export class DeleteElynkChecklistRequest {
    documentTypeId: number;
    packetId: string;
    constructor(documentId: number, packetId: string) {
        this.documentTypeId = documentId;
        this.packetId = packetId;
    }
}

export class DeleteElynkChecklistResponse {
    statusCode: number;
}

/**   eLynk Add */

export class SaveElynkAddRequest {
    documentTypeId: number;
    packetId: string;
    add: ELynkPacketAdd;
    constructor(documentId: number, packetId: string, add: ELynkPacketAdd) {
        this.documentTypeId = documentId;
        this.packetId = packetId;
        this.add = add;
    }
}

export class SaveElynkAddResponse {
    statusCode: number;
}

export class DeleteElynkAddRequest {
    documentTypeId: number;
    packetId: string;
    constructor(documentId: number, packetId: string) {
        this.documentTypeId = documentId;
        this.packetId = packetId;
    }
}

export class DeleteElynkAddResponse {
    statusCode: number;
}

export class DeleteElynkPacketRequest {
    documentTypeId: number;
    packetId: string;
    constructor(documentId: number, packetId: string) {
        this.documentTypeId = documentId;
        this.packetId = packetId;
    }
}

export class DeleteElynkPacketResponse {
    statusCode: number;
}

export class GetElynkPacketsRequest {
    documentTypeId: number;
    constructor(documentId: number) {
        this.documentTypeId = documentId;
    }
}

export class GetElynkPacketsResponse {
    statusCode: number;
    packets: ELynkPacket[];
}

/* Classification */
export class GetClassificationRequest {
    documentTypeId: number;
    constructor(documentTypeId: number) {
        this.documentTypeId = documentTypeId;
    }
}

export class GetClassificationResponse {
    classification: DocumentTypeDocumentClassification;
}

export class SaveClassificationRequest {
    documentTypeId: number;
    classification: DocumentTypeDocumentClassification;

    constructor(documentTypeId: number, classification: DocumentTypeDocumentClassification) {
        this.documentTypeId = documentTypeId;
        this.classification = classification;
    }
}

export class SaveClassificationResponse {
    statusCode: number;
}

export class DeleteClassificationRequest {
    documentTypeId: number;
    constructor(documentTypeId: number) {
        this.documentTypeId = documentTypeId;
    }
}

export class DeleteClassificationResponse {
    statusCode: number;
}

/* Template Manager */

export class GetTemplateManagerRequest {
    documentTypeId: number;
    constructor(documentTypeId: number) {
        this.documentTypeId = documentTypeId;
    }
}

export class GetTemplateManagerResponse {
    templateManager: DocumentTypeTemplateManager;
}

export class SaveTemplateManagerRequest {
    documentTypeId: number;
    templateManager: DocumentTypeTemplateManager;

    constructor(documentTypeId: number, templateManager: DocumentTypeTemplateManager) {
        this.documentTypeId = documentTypeId;
        this.templateManager = templateManager;
    }
}

export class SaveTemplateManagerResponse {
    statusCode: number;
}


export class DeleteTemplateManagerRequest {
    documentTypeId: number;
    constructor(documentTypeId: number) {
        this.documentTypeId = documentTypeId;
    }
}

export class DeleteTemplateManagerResponse {
    statusCode: number;
}
